import { useCallback, useMemo } from 'react';
import { useRemoteDictionariesQuery } from 'shared/hooks/api/remoteDictionaries/remoteDictionaries.generated';
import { mapArrayIntoOptions } from 'shared/utils/mapArrayIntoOptions';
import { JobPosition } from 'types/JobPosition';

export const useJobPositions = () => {
  const { data } = useRemoteDictionariesQuery();
  const { jobPositions } = data ?? { jobPositions: [] };

  const options = useMemo(
    () => mapArrayIntoOptions(jobPositions, 'name', 'jobPositionId'),
    [jobPositions],
  );

  const getJobPositionById = useCallback(
    (id: string): JobPosition | null =>
      (jobPositions?.find(({ jobPositionId }) => jobPositionId === id) as JobPosition) || null,
    [jobPositions],
  );

  const jobPositionIdsWithMainTechnologies = useMemo(
    () =>
      jobPositions.reduce<Record<string, number>>(
        (acc, { jobPositionId, availableMainTechnologies }) => {
          if (availableMainTechnologies.length) {
            acc[jobPositionId] = availableMainTechnologies.length;
          }
          return acc;
        },
        {},
      ),
    [jobPositions],
  );

  return {
    options,
    getJobPositionById,
    jobPositions,
    jobPositionIdsWithMainTechnologies,
  };
};
